import { globalActor } from "../../state/GlobalContextProvider";
import { useSelector } from "@xstate/react";
export default function Continue(props) {
  const state = useSelector(globalActor, (snapshot) => snapshot.value);
  const hideDisclaimer = useSelector(
    globalActor,
    (snapshot) => snapshot.context.hideDisclaimer
  );
  const hide = state === "blinkReflex3Animation" && hideDisclaimer;
  // console.log("Continue state: ", state);
  return (
    <div className="Continue Screen">
      <button
        onClick={(_) => globalActor.send({ type: "CONTINUE" })}
        className={state.match("Animation") ? "" : "Active"}
      >
        CONTINUE
      </button>

      {!state.match("prime") &&
        !state.match("whatPatients") &&
        !state.match("ready") &&
        state !== "dropSize1" &&
        !hide && (
          <p style={{ lineHeight: "1.5" }}>
            MIEBO is contraindicated in patients with known hypersensitivity to
            perfluorohexyloctane.
          </p>
        )}
      <p>Not actual size.</p>
    </div>
  );
}
